import { render, staticRenderFns } from "./TablePromo.vue?vue&type=template&id=8becce30"
import script from "./TablePromo.vue?vue&type=script&lang=js"
export * from "./TablePromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports